import type {
    Animated
} from "react-native";
import type {
    MotionThemeType
} from "./useMotionTiming";
import {
    MOTION_PRESS_SCALE
} from "./timing";
import useAnimatedState from "./useAnimatedState";
import useReducedMotion from "./useReducedMotion";

export type PressScaleConstantType = {
    customTheme?: MotionThemeType;
    isDisabled?: boolean;
    isEnabled?: boolean;
    isPressed: boolean;
};

export type PressScaleStyleType = {
    transform: Array<{
        scale: Animated.Value;
    }>;
};

const usePressScale = ({
    isDisabled = false,
    isEnabled = true,
    customTheme,
    isPressed
}: PressScaleConstantType): PressScaleStyleType | undefined => {
    const isReduceMotionEnabled = useReducedMotion();

    const isActive = isEnabled && !isReduceMotionEnabled;

    const scale = useAnimatedState({
        value: isActive && isPressed && !isDisabled ? MOTION_PRESS_SCALE : 1,
        intent: "press",
        customTheme
    });

    if(!isActive) {
        return undefined;
    }

    return {
        transform: [
            {
                scale
            }
        ]
    };
};
export default usePressScale;
